import { IGlobalActions, GlobalActions } from "../actions/global.action";
import { IList } from "../../interfaces/default";

export interface IGlobalState {
  countries: {
    isLoading: boolean;
    data?: Array<IList>;
    error?: string;
  };
  states: {
    isLoading: boolean;
    data?: Array<IList>;
    error?: string;
  };
  iosVersion: {
    isLoading: boolean;
    data?: Array<IList>;
    error?: string;
  };
  androidVersion: {
    isLoading: boolean;
    data?: Array<IList>;
    error?: string;
  };
  ageGroup: {
    isLoading: boolean;
    data?: Array<IList>;
    error?: string;
  };
  language: {
    isLoading: boolean;
    data?: Array<IList>;
    error?: string;
  };
  interest: {
    isLoading: boolean;
    data?: Array<IList>;
    error?: string;
  };
}

const initialState = {
  iosVersion: {
    isLoading: false,
  },
  androidVersion: {
    isLoading: false,
  },
  ageGroup: {
    isLoading: false,
  },
  language: {
    isLoading: false,
  },
  interest: {
    isLoading: false,
  },
  countries: {
    isLoading: false,
  },
  states: {
    isLoading: false,
  },
};

export const globalReducer = (
  state = initialState,
  action: IGlobalActions,
): IGlobalState => {
  switch (action.type) {
    case GlobalActions.STATES:
      return {
        ...state,
        states: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case GlobalActions.STATES_SUCCESS:
      return {
        ...state,
        states: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case GlobalActions.STATES_FAILURE:
      return {
        ...state,
        states: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case GlobalActions.INTEREST:
      return {
        ...state,
        interest: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case GlobalActions.INTEREST_SUCCESS:
      return {
        ...state,
        interest: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case GlobalActions.INTEREST_FAILURE:
      return {
        ...state,
        interest: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case GlobalActions.IOS_VERSION:
      return {
        ...state,
        iosVersion: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case GlobalActions.IOS_VERSION_SUCCESS:
      return {
        ...state,
        iosVersion: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case GlobalActions.IOS_VERSION_FAILURE:
      return {
        ...state,
        iosVersion: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case GlobalActions.ANDROID_VERSION:
      return {
        ...state,
        androidVersion: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case GlobalActions.ANDROID_VERSION_SUCCESS:
      return {
        ...state,
        androidVersion: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case GlobalActions.ANDROID_VERSION_FAILURE:
      return {
        ...state,
        androidVersion: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case GlobalActions.AGE_GROUP:
      return {
        ...state,
        ageGroup: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case GlobalActions.AGE_GROUP_SUCCESS:
      return {
        ...state,
        ageGroup: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case GlobalActions.AGE_GROUP_FAILURE:
      return {
        ...state,
        ageGroup: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case GlobalActions.LANGUAGE:
      return {
        ...state,
        language: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case GlobalActions.LANGUAGE_SUCCESS:
      return {
        ...state,
        language: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case GlobalActions.LANGUAGE_FAILURE:
      return {
        ...state,
        language: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case GlobalActions.COUNTRIES:
      return {
        ...state,
        countries: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case GlobalActions.COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case GlobalActions.COUNTRIES_FAILURE:
      return {
        ...state,
        countries: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    default:
      return state;
  }
};
